import { CustomSelect } from '@/components/inputs/CustomSelect'
import { ItemSource } from '@/components/inputs/custom-select-state-observable'
import { useCustomSelectStateFromItemSource } from '@/components/inputs/item-source-hook'
import { useMemo } from 'react'

const matches = (item: string, text: string) =>
  item.toLowerCase().includes(text.toLowerCase())

export interface MultiStringSelectProps {
  value: string[]
  options: readonly string[]
  onChange: (value: string[]) => void
  placeholder?: string
  isDisabled?: boolean
  testId?: string
}

export function MultiStringSelect({
  value,
  options,
  onChange,
  placeholder,
  isDisabled,
  testId,
}: MultiStringSelectProps) {
  const itemSource = useMemo(
    () => ItemSource.static([...options], matches),
    [options],
  )
  const selectProps = useCustomSelectStateFromItemSource({ itemSource })
  return (
    <CustomSelect
      {...selectProps}
      multi
      persist
      value={value}
      onChange={(next) => onChange(next ?? [])}
      placeholder={placeholder}
      isDisabled={isDisabled}
      testId={testId}
    />
  )
}

export interface SingleStringSelectProps {
  value: string | undefined
  options: readonly string[]
  onChange: (value: string | undefined) => void
  placeholder?: string
  isDisabled?: boolean
  testId?: string
}

export function SingleStringSelect({
  value,
  options,
  onChange,
  placeholder,
  isDisabled,
  testId,
}: SingleStringSelectProps) {
  const itemSource = useMemo(
    () => ItemSource.static([...options], matches),
    [options],
  )
  const selectProps = useCustomSelectStateFromItemSource({ itemSource })
  return (
    <CustomSelect
      {...selectProps}
      multi={false}
      value={value}
      onChange={(next) => onChange(next ?? undefined)}
      placeholder={placeholder}
      isDisabled={isDisabled}
      testId={testId}
    />
  )
}
